import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useSelector } from "react-redux";
export var useSortList = function () {
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var columnDefs = {
        ratingAsc: {
            name: "Name - A to Z",
            value: "display_name-asc",
            type: false,
            filterValue: "display_name",
        },
        ratingDesc: {
            name: "Name - Z to A",
            value: "display_name-desc",
            type: true,
            filterValue: "display_name",
        },
        interestFrequencyAsc: {
            name: "Payout Freq. - Lowest to Highest",
            value: "payout-asc",
            type: false,
            filterValue: "interest_frequency",
        },
        interestFrequencyDesc: {
            name: "Payout Freq. - Highest to Lowest",
            value: "payout-desc",
            type: true,
            filterValue: "interest_frequency",
        },
        priceRangeAsc: {
            name: "Price Range per Qty. - Low to High",
            value: "price-range-asc",
            type: false,
            filterValue: "price_range",
        },
        priceRangeDesc: {
            name: "Price Range per Qty. - High to Low",
            value: "price-range-desc",
            type: true,
            filterValue: "price_range",
        },
        avlAtyAsc: {
            name: "Avl. Qty - Lowest to Highest",
            value: "avl-qty-asc",
            type: false,
            filterValue: "avl_qty",
        },
        avlAtyDesc: {
            name: "Avl. Qty - Highest to Lowest",
            value: "avl-qty-desc",
            type: true,
            filterValue: "avl_qty",
        },
        couponRateAsc: {
            name: "Coupon - Low to High",
            value: "coupon-asc",
            type: false,
            filterValue: "coupon_rate",
        },
        couponRateDesc: {
            name: "Coupon - High to Low",
            value: "coupon-desc",
            type: true,
            filterValue: "coupon_rate",
        },
        maturityDateAsc: {
            name: "Maturity Date Remaining Period - Low to High",
            value: "maturity_Date-asc",
            type: false,
            filterValue: "maturitydate",
        },
        maturityDateDesc: {
            name: "Maturity Date Remaining Period - High to Low",
            value: "maturity_Date-desc",
            type: true,
            filterValue: "maturitydate",
        },
    };
    switch (subCategoryId) {
        case ESubProductIds.NCD:
            return [
                columnDefs.ratingAsc,
                columnDefs.ratingDesc,
                columnDefs.interestFrequencyAsc,
                columnDefs.interestFrequencyDesc,
                columnDefs.priceRangeAsc,
                columnDefs.priceRangeDesc,
                columnDefs.avlAtyAsc,
                columnDefs.avlAtyDesc,
                columnDefs.couponRateAsc,
                columnDefs.couponRateDesc,
            ];
        case ESubProductIds.Bonds:
            return [
                columnDefs.ratingAsc,
                columnDefs.ratingDesc,
                columnDefs.interestFrequencyAsc,
                columnDefs.interestFrequencyDesc,
                columnDefs.priceRangeAsc,
                columnDefs.priceRangeDesc,
                columnDefs.maturityDateAsc,
                columnDefs.maturityDateDesc,
                columnDefs.couponRateAsc,
                columnDefs.couponRateDesc,
            ];
        case ESubProductIds.StructuredProducts:
            return [
                columnDefs.ratingAsc,
                columnDefs.ratingDesc,
                columnDefs.priceRangeAsc,
                columnDefs.priceRangeDesc,
                columnDefs.maturityDateAsc,
                columnDefs.maturityDateDesc,
            ];
        case ESubProductIds.UnlistedShares:
            return [
                columnDefs.ratingAsc,
                columnDefs.ratingDesc,
                columnDefs.priceRangeAsc,
                columnDefs.priceRangeDesc,
                columnDefs.avlAtyAsc,
                columnDefs.avlAtyDesc,
            ];
    }
};
